export default "__VITE_ASSET__BCCJz6rJ__"